import React from "react";
// import WalletConnect from "./WalletConnectModal";

import { NetworkErrorMessage } from "./NetworkErrorMessage";

export function ConnectWallet({ connectWallet, networkError, dismiss }) {
  return (
    <div className="container padding-top padding-bottom">
      <div className="row justify-content-md-center">
        <div className="col-12 text-center">
          {/* Metamask network should be set to Localhost:8545. */}
          {networkError && (
            <NetworkErrorMessage message={networkError} dismiss={dismiss} />
          )}
        </div>
        </div>
        <div className="row justify-content-md-center">
        <div className="col-12 col-lg-8  p-4 text-center">
          <h2>Connect Wallet</h2>
          <p>Connect Your Wallet for Quantum Energy</p>
          <button className="default-btn" type="button" onClick={connectWallet}>
            Connect Wallet
          </button>
        </div>
      </div>
    </div>
  );
}
